(function () {
  function cardStep(scroller) {
    var card = scroller.querySelector('.pd26-blogdetail-product');
    if (!card) return Math.round(scroller.clientWidth * 0.7);

    var track = scroller.querySelector('.pd26-blogdetail-products__track');
    var styles = window.getComputedStyle(track || scroller);
    var gap = parseFloat(styles.columnGap || styles.gap || '24') || 24;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function bindProducts(root) {
    if (!root || root.getAttribute('data-pd26-blogdetail-bound') === 'true') return;

    var scroller = root.querySelector('[data-pd26-blogdetail-scroller]');
    var prevButtons = root.querySelectorAll('[data-pd26-blogdetail-prev]');
    var nextButtons = root.querySelectorAll('[data-pd26-blogdetail-next]');
    if (!scroller) return;

    root.setAttribute('data-pd26-blogdetail-bound', 'true');

    var target = scroller.scrollLeft;
    var fromArrow = false;

    scroller.addEventListener('scroll', function () {
      if (!fromArrow) target = scroller.scrollLeft;
    });

    function scrollByDir(dir) {
      var step = cardStep(scroller);
      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);

      if (dir > 0 && target >= max - 4) {
        target = 0;
      } else if (dir < 0 && target <= 4) {
        target = max;
      } else {
        target = Math.min(max, Math.max(0, target + dir * step));
      }

      fromArrow = true;
      scroller.scrollTo({
        left: target,
        behavior: 'smooth'
      });

      window.clearTimeout(scroller._pd26ScrollTimer);
      scroller._pd26ScrollTimer = window.setTimeout(function () {
        fromArrow = false;
        target = scroller.scrollLeft;
      }, 450);
    }

    prevButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        scrollByDir(-1);
      });
    });

    nextButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        scrollByDir(1);
      });
    });
  }

  function bindTop(button) {
    if (!button || button.getAttribute('data-pd26-blogdetail-top') === 'true') return;
    button.setAttribute('data-pd26-blogdetail-top', 'true');
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function bindSubscribe(box) {
    if (!box || box.getAttribute('data-pd26-blogdetail-subscribe-bound') === 'true') return;

    var toggle = box.querySelector('[data-pd26-blogdetail-subscribe-toggle]');
    var form = box.querySelector('.pd26-blogdetail-subscribe__form');
    if (!toggle || !form) return;

    box.setAttribute('data-pd26-blogdetail-subscribe-bound', 'true');
    toggle.addEventListener('click', function () {
      var collapsed = box.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
    form.addEventListener('submit', function (event) {
      submitBlogSubscribe(box, form, event);
    });
  }

  function klaviyoIds(box) {
    var company = (box.getAttribute('data-klaviyo-company') || '').trim();
    var list = (box.getAttribute('data-klaviyo-list') || '').trim();
    if (!company || !list) {
      var nl = document.querySelector('[data-pongbot26-klaviyo-company-id]');
      if (nl) {
        company = company || (nl.getAttribute('data-pongbot26-klaviyo-company-id') || '').trim();
        list = list || (nl.getAttribute('data-pongbot26-klaviyo-list-id') || '').trim();
      }
    }
    return { company: company, list: list };
  }

  function showSubscribeMessage(box, text, isError) {
    var msg = box.querySelector('.pd26-blogdetail-subscribe__msg');
    if (!msg) return;
    msg.hidden = false;
    msg.classList.toggle('pd26-blogdetail-subscribe__msg--error', !!isError);
    msg.textContent = text;
  }

  function submitBlogSubscribe(box, form, event) {
    var input = form.querySelector('input[type="email"]');
    var email = input && input.value ? input.value.trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      event.preventDefault();
      showSubscribeMessage(box, 'Please enter a valid email address.', true);
      return;
    }

    var ids = klaviyoIds(box);
    if (!ids.company || !ids.list) return;

    event.preventDefault();
    var button = form.querySelector('.pd26-blogdetail-subscribe__btn');
    if (button) button.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(ids.company), {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        revision: '2026-01-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Blog detail subscribe',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: ids.list } } }
        }
      })
    })
      .then(function (res) {
        if (res.status === 202 || res.ok) return;
        throw new Error('fail');
      })
      .then(function () {
        showSubscribeMessage(box, 'Thanks for subscribing.', false);
        form.reset();
      })
      .catch(function () {
        showSubscribeMessage(box, 'Subscription failed. Please try again.', true);
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  }

  function bindCopy(button) {
    if (!button || button.getAttribute('data-pd26-blogdetail-copy-bound') === 'true') return;
    button.setAttribute('data-pd26-blogdetail-copy-bound', 'true');
    button.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).catch(function () {
          copyWithFallback(url);
        });
        return;
      }
      copyWithFallback(url);
    });
  }

  function copyWithFallback(url) {
    var input = document.createElement('textarea');
    input.value = url;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
    } catch (error) {}
    document.body.removeChild(input);
  }

  function bindNativeShare(button) {
    if (!button || button.getAttribute('data-pd26-blogdetail-share-bound') === 'true') return;
    button.setAttribute('data-pd26-blogdetail-share-bound', 'true');
    button.addEventListener('click', function () {
      if (!navigator.share) return;
      var url = button.getAttribute('data-share-url') || window.location.href;
      var title = button.getAttribute('data-share-title') || document.title;
      navigator.share({ title: title, url: url }).catch(function () {});
    });
  }

  var headerOffsetBound = false;

  function syncHeaderOffset() {
    var sections = document.querySelectorAll('.pd26-blogdetail-article');
    if (!sections.length) return;

    var measured = 0;
    var header = document.querySelector('.xo-header__body');
    if (header) {
      measured = Math.round(header.getBoundingClientRect().height);
    }

    sections.forEach(function (section) {
      if (section.hasAttribute('data-header-offset')) return;
      if (measured > 0) {
        section.style.setProperty('--pd26-bd-header-offset', measured + 'px');
      } else {
        section.style.removeProperty('--pd26-bd-header-offset');
      }
    });
  }

  function bindHeaderOffset() {
    syncHeaderOffset();
    if (headerOffsetBound) return;
    headerOffsetBound = true;
    window.addEventListener('resize', syncHeaderOffset);
  }

  function init(scope) {
    var root = scope || document;
    bindHeaderOffset();
    root.querySelectorAll('[data-pd26-blogdetail-products]').forEach(bindProducts);
    root.querySelectorAll('[data-pd26-blogdetail-top]').forEach(bindTop);
    root.querySelectorAll('[data-pd26-blogdetail-subscribe]').forEach(bindSubscribe);
    root.querySelectorAll('[data-pd26-blogdetail-copy]').forEach(bindCopy);
    root.querySelectorAll('[data-pd26-blogdetail-share]').forEach(bindNativeShare);
    if (root.hasAttribute && root.hasAttribute('data-pd26-blogdetail-products')) {
      bindProducts(root);
    }
    if (root.hasAttribute && root.hasAttribute('data-pd26-blogdetail-top')) {
      bindTop(root);
    }
    if (root.hasAttribute && root.hasAttribute('data-pd26-blogdetail-subscribe')) {
      bindSubscribe(root);
    }
    if (root.hasAttribute && root.hasAttribute('data-pd26-blogdetail-copy')) {
      bindCopy(root);
    }
    if (root.hasAttribute && root.hasAttribute('data-pd26-blogdetail-share')) {
      bindNativeShare(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
